"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const address_repository_1 = require("./address.repository");
const address_response_dto_1 = require("./dto/address-response.dto");
const class_transformer_1 = require("class-transformer");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
/**
 * Service for managing addresses.
 */
let AddressService = class AddressService {
    constructor(
    /**
     * Repository service for address operations.
     */
    addressRepository) {
        this.addressRepository = addressRepository;
    }
    /** Creates a new address. */
    async addAddress(createAddress, userId) {
        try {
            createAddress.createdBy = userId;
            createAddress.updatedBy = userId;
            createAddress.createdAt = new Date();
            createAddress.updatedAt = new Date();
            const address = await this.addressRepository.createAddress(createAddress);
            return (0, class_transformer_1.plainToInstance)(address_response_dto_1.AddressResponseDto, address, {
                excludeExtraneousValues: true,
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, messages_1.errorMessages.addressCreationFailed));
        }
    }
    /** Retrieves all addresses.*/
    async getAddressList(page, limit, search, sort) {
        try {
            const { data, count } = await this.addressRepository.fetchAllAddressDetails(page, limit, search, sort);
            // addressData: plainToInstance(AddressResponseFetchDto, addressData, { excludeExtraneousValues: true }),
            return {
                data,
                count,
            };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, messages_1.errorMessages.addressFetchFailed));
        }
    }
    /** Retrieves an address by ID.*/
    async getAddressById(addressId) {
        try {
            const address = await this.addressRepository.getAddressDetails(addressId);
            // return plainToInstance(AddressResponseFetchDto, address, { excludeExtraneousValues: true });
            return address;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, messages_1.errorMessages.addressFetchFailed));
        }
    }
    /** Updates an address by ID.*/
    async updateAddressById(addressId, updateAddress, userId) {
        try {
            updateAddress.updatedAt = new Date();
            updateAddress.updatedBy = userId;
            const updatedAddress = await this.addressRepository.updateAddressDetails(addressId, updateAddress);
            // return plainToInstance(AddressResponseDto, updatedAddress, { excludeExtraneousValues: true });
            return updatedAddress;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, messages_1.errorMessages.addressUpdationFailed));
        }
    }
    /** Removes an address by ID. */
    async deleteAddressById(addressId) {
        try {
            const address = await this.getAddressById(addressId);
            await this.addressRepository.removeAddressDetails(address);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(enum_1.statusCode.internalServerError, messages_1.errorMessages.addressDeletionFailed));
        }
    }
    /** Retrieves all the region details */
    async getAllRegions() {
        try {
            return await this.addressRepository.findAllRegions();
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.regionFetchFailed);
        }
    }
    /** Retrieves all the countries */
    async getAllCountries() {
        try {
            return await this.addressRepository.fetchAllCountries();
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.countryFecthFailed);
        }
    }
    /** Retrieves all the country based upon region */
    async getCountries(regionId) {
        try {
            return await this.addressRepository.findCountries(regionId);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.countryFecthFailed);
        }
    }
    /** Retrieves all the states based upon country */
    async getStates(countryId) {
        try {
            return await this.addressRepository.findStates(countryId);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.stateFecthFailed);
        }
    }
    /** Retrieves all the cities based upon state */
    async getCities(stateId) {
        try {
            return await this.addressRepository.findCities(stateId);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.cityFetchFailed);
        }
    }
};
exports.AddressService = AddressService;
exports.AddressService = AddressService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof address_repository_1.AddressRepository !== "undefined" && address_repository_1.AddressRepository) === "function" ? _a : Object])
], AddressService);
